export { default } from './ServiceDeprecationBanner';
